export default "__VITE_ASSET__BnjmWgpZ__"